;var Product = function(selector, options) {

  var container = $(selector);
  if (!container.length) {
    return;
  }

  var image = null;

  var isVertical = options.direction === 'vertical';
  var isLoop = options.type === '360';

  var deltaDirection = isVertical ? 'deltaY' : 'deltaX'; 

  var totalFrames = options.frames;
  var currentFrame = 0;
  var panStartFrame = 0;

  var hammer = new Hammer(container.get(0));
  hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL }); // improve vertical listener
  hammer.on('panstart', onPanStart);
  hammer.on('pan', onPan);

  image = $('<img unselectable="on" ondragstart="return false;" class="image" />');
  container.append(image);

  var firstFrame = options.firstFrame ? options.firstFrame - 1 : 0;
  var lastFrame = options.lastFrame ? options.lastFrame - 1 : firstFrame;
  showFrame(firstFrame);

  function onPanStart(e) {
    panStartFrame = currentFrame;

    // close bottom navigation
    Navigation.close();
  }

  function onPan(e) {
    var delta = isVertical ? e.deltaY : e.deltaX;
    var diff = delta * 1/15; // magic number
    var frame = panStartFrame - diff;
    showFrame(frame);
  };
  
  function showFrame(frame) {
    if (isLoop) {
      while (frame < 0) {
        frame += totalFrames;
      }
      while (frame > totalFrames - 1) {
        frame -= totalFrames - 1;
      }
    } else {
      if (frame < 0) {
        frame = 0;
      }
      if (frame > totalFrames - 1) {
        frame = totalFrames - 1;
      }
    }

    currentFrame = Math.round(frame);

    var number = fillZero(currentFrame+1);
    var url = Preloader.getUrl('images/sequences/'+options.folder+'/'+number+'.jpg');
    image.attr('src', url);
  };

  function transitionOut(type, callback) {
    var targetFrame = type === 'forward' ? lastFrame : firstFrame;

    // sometimes is faster to loop than return to first frame
    var distance = Math.abs(currentFrame - targetFrame);
    if (isLoop) {
      var targetFrameLoop = targetFrame + totalFrames - 1;
      var distanceLoop = Math.abs(currentFrame - targetFrameLoop);
      if (distanceLoop < distance) {
        distance = distanceLoop;
        targetFrame = targetFrameLoop;
      }
    }

    if (distance < 1) {
      if (callback) {
        callback();
      }
      return;
    }

    var tempObj = { value: currentFrame };
    anime({
      targets: tempObj,
      value: targetFrame,
      easing: 'linear',
      duration: Math.min(distance * 50, 1000),
      update: function() {
        var frame = Number(tempObj.value);
        showFrame(frame);
      },
      complete: function() {
        if (callback) {
          callback();
        }
      }
    });
  }

  function transitionIn(type) {
    var targetFrame = type === 'backward' ? lastFrame : firstFrame;
    showFrame(targetFrame);
  }

  return {
    transitionOut: transitionOut,
    transitionIn: transitionIn,
  }

};
